import { render, staticRenderFns } from "./CreateSimpleHTML.vue?vue&type=template&id=ba497874&scoped=true&"
import script from "./CreateSimpleHTML.vue?vue&type=script&lang=js&"
export * from "./CreateSimpleHTML.vue?vue&type=script&lang=js&"
import style0 from "./CreateSimpleHTML.vue?vue&type=style&index=0&id=ba497874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba497874",
  null
  
)

export default component.exports